"use strict";

var _interopRequireDefault = require("babel-runtime/helpers/interop-require-default")["default"];

exports.__esModule = true;
exports["default"] = NotFound;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function NotFound() {
  return _react2["default"].createElement(
    "div",
    { className: "container-fluid text-center" },
    _react2["default"].createElement("br", null),
    _react2["default"].createElement("br", null),
    _react2["default"].createElement(
      "h1",
      { className: "error-title" },
      "404"
    ),
    _react2["default"].createElement(
      "h6",
      { className: "text-semibold content-group" },
      "Oops, an error has occurred. Page not found!"
    )
  );
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NotFound.js
 ** module id = 972
 ** module chunks = 2
 **/